import React, { useState } from 'react';
import EmailIcon from '@mui/icons-material/Email';
import SendIcon from '@mui/icons-material/Send';
import PhoneIcon from '@mui/icons-material/Phone';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useTranslation } from "react-i18next"

const ContactSection = () => {
  const { t } = useTranslation();
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const form = e.target;
      const response = await fetch(form.action, {
        method: form.method,
        body: new FormData(form),
        headers: {
          Accept: 'application/json'
        }
      });
      
      if (response.ok) {
        setSnackbarMessage('Message sent successfully!');
        setSnackbarSeverity('success');
        form.reset();
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      setSnackbarMessage('Failed to send message. Please try again.');
      setSnackbarSeverity('error');
    }
    
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  return (
    <section className="flex justify-center px-4 py-8 bg-light-blue sm:px-8 scroll-mt-16" id='contact'>
      <div className="flex flex-col p-6 w-full max-w-6xl rounded-xl border shadow-lg bg-background sm:p-8 md:flex-row border-secondary">
        {/* Form Section */}
        <div className="flex-1 mb-8 md:pr-8 md:mb-0">
          <h2 className="mb-4 text-2xl font-bold sm:text-3xl">{t("contact")}</h2>
          <form 
            action={process.env.REACT_APP_FORMSPREE_ENDPOINT} 
            method="POST" 
            onSubmit={handleSubmit}
          >
            <label className="block mb-2 text-sm font-bold" htmlFor="message">
              {t("message")}
            </label>
            <textarea
              id="message"
              name="message"
              className="p-3 mb-4 w-full text-black bg-gray-100 rounded-lg border border-gray-300 shadow-sm"
              rows="5"
              placeholder={t("write your message...")}
              required
            />

            <label className="block mb-2 text-sm font-bold" htmlFor="name">
              {t("name")}
            </label>
            <input
              id="name"
              name="name"
              className="p-3 mb-4 w-full text-black bg-gray-100 rounded-lg border border-gray-300 shadow-sm"
              type="text"
              placeholder={t("your name")}
              required
            />

            <label className="block mb-2 text-sm font-bold" htmlFor="email">
              {t("email")}
            </label>
            <input
              id="email"
              name="email"
              className="p-3 mb-4 w-full text-black bg-gray-100 rounded-lg border border-gray-300 shadow-sm"
              type="email"
              placeholder={t("your email")}
              required
            />

            <button
              type="submit"
              className="flex justify-center items-center px-4 py-2 text-white bg-blue-500 rounded-lg shadow transition hover:bg-blue-600"
            >
              <SendIcon className="mr-2" />
              {t("send message")}
            </button>
          </form>
        </div>

        {/* Contact Info Section */}
        <div className="flex flex-col flex-1 items-center mt-8 md:mt-0 md:pl-8 md:items-end">
          <h3 className="mb-4 text-lg font-bold">Email</h3>
          <div className="flex items-center mb-4">
            <EmailIcon className="mr-2 text-primary" />
            <a
              href="mailto:johnlinthicum1@gmail.com"
              className="text-primary hover:underline"
            >
              johnlinthicum1@gmail.com
            </a>
          </div>

          <h3 className="mb-4 text-lg font-bold">Phone</h3>
          <div className="flex items-center mb-4">
            <PhoneIcon className="mr-2 text-primary" />
            <a
              href="tel:+49 1573 7884080"
              className="text-primary hover:underline"
            >
              +49 1573 7884080
            </a>
          </div>
        </div>
      </div>

      {/* Snackbar for notifications */}
      <Snackbar 
        open={openSnackbar} 
        autoHideDuration={6000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </section>
  );
};

export default ContactSection;
